
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { Link } from 'react-router-dom';
import { logoutUser } from "../../slices/thunks";
import { useSelector, useDispatch } from "react-redux";
import withRouter from "../../Components/Common/withRouter";
import { createSelector } from "reselect";
import { signOut } from '@aws-amplify/auth';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";

//import images
import logoLight from "../../assets/images/BeaconLogo.png"

const Logout = (props) => {
  const dispatch = useDispatch();

  const isUserLogoutSelector = createSelector(
    (state) => state.Login,
    (isUserLogout) => isUserLogout.isUserLogout
  );
  const isUserLogout = useSelector(isUserLogoutSelector);

  useEffect(() => {
    const signOutUser = async () => {
      try {
        // First dispatch logout to clear storage immediately
        // This prevents any auth checks from seeing stale data
        await dispatch(logoutUser());
        // Then call AWS Amplify signOut
        await signOut();
      } catch (error) {
        console.error('Error signing out: ', error);
        // Even on error, ensure logout is dispatched to clear local state
        await dispatch(logoutUser());
      }
    };

    // Only run logout once when component mounts
    signOutUser();
    // dispatch is stable from Redux, safe to include in dependencies
  }, [dispatch]);
  document.title = "Beacon Eng. Chat Bot | Logout";
  return (
    <>
      <div className="auth-page-content">
        <div className="auth-page-wrapper">
          <ParticlesAuth>
            <div className="auth-page-content">
              <Container>
                <Row>
                  <Col lg={12}>
                    <div className="text-center mt-sm-5 mb-4 text-white-50">
                      <div>
                        <Link to="/dashboard" className="d-inline-block auth-logo">
                          <img src={logoLight} alt="" height="50" />
                        </Link>
                      </div>
                      
                    </div>
                  </Col>
                </Row>

                <Row className="justify-content-center">
                  <Col md={8} lg={6} xl={5}>
                    <Card className="mt-4">
                      <CardBody className="p-4 text-center">
                        <lord-icon
                          src="https://cdn.lordicon.com/hzomhqxz.json"
                          trigger="loop"
                          colors="primary:#405189,secondary:#08a88a"
                          style={{ width: "180px", height: "180px" }}>
                        </lord-icon>


                        <div className="mt-4 pt-2">
                          <h5>You are Logged Out</h5>
                          <p className="text-muted">Thank you for using <span className="fw-semibold">Beacon Eng. </span>Chat Bot</p>
                          <div className="mt-4">
                            <Link to="/login" className="btn btn-success w-100">Sign In</Link>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Container>
            </div>
          </ParticlesAuth>

        </div>
      </div >
    </>);
};

Logout.propTypes = {
  history: PropTypes.object,
};

export default withRouter(Logout);
